// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useParams } from '@tanstack/react-router';

// material ui icons
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';

// material ui
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts';

// api
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// shared components
import InfoTooltipIcon from '@/components/ui/icon/InfoTooltipIcon';

// components
import { formatNumber } from '@/utils/formatters';

const GoCard = ({ openGoShares, number, children }) => {
  const { t } = useTranslation('energyxplorer-esg');

  const { energyGroupId } = useParams({ strict: false });

  const { data: selectedEnergyGroup } = useGetEnergyGroupQuery(
    { groupId: energyGroupId },
    {
      skip: !energyGroupId,
    },
  );

  const isPortfolio = selectedEnergyGroup?.type?.includes('Portfolio');

  return (
    <Card sx={{ p: 1, borderRadius: 2, minHeight: 240, height: '100%' }}>
      <CardContent>
        <Stack
          direction="column"
          color="inherit"
          sx={{
            transition: 'box-shadow 0.3s ease',
            height: '100%',
            background: 'transparent',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  {t('go_card.label')}
                </Typography>
                <InfoTooltipIcon title={t('go_card.description')} />
              </Box>
              {!isPortfolio && (
                <IconButton
                  className="non-printable"
                  size="small"
                  onClick={() => openGoShares(true)}
                  aria-label="slice-mode-selector"
                  sx={{ borderRadius: 1 }}
                >
                  <SettingsRoundedIcon />
                </IconButton>
              )}
            </Box>
          </Box>
          <div>
            {children && (
              <Box
                sx={{
                  mt: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {children}
              </Box>
            )}
            <Gauge
              width={200}
              height={130}
              value={number * 100}
              cornerRadius={'40%'}
              startAngle={-110}
              endAngle={110}
              text={`${formatNumber(number * 100)}%`}
              sx={(theme) => ({
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 40,
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: '#52b202',
                  opacity: 0.8,
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                  fill: theme.palette.text.disabled,
                  opacity: 0.5,
                },
                margin: '0 auto',
              })}
            />
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default GoCard;
